export const PRODUCTS = {  //prod
  KI_KOMPETENZNACHWEIS: {
    id: 'prod_SjA0w1Noq5WOrx',
    priceId: 'price_1Rnhg4K6f2u6ftr9KRpOPkV4',
    description: 'Die Einzellizenz für den KI-Kompetenznachweis nach EU AI Act der KI Navigatoren GmbH beinhaltet den Zugang zur Schulungsplattform, die Durchführung der Schulung sowie die Teilnahme am Abschlusstest samt Zertifikatserstellung.',
    mode: 'payment'
  }
} as const;

/*cexport const PRODUCTS = {    // test
  KI_KOMPETENZNACHWEIS: {
    id: 'prod_SQQB9cy3I89MU4',
    priceId: 'price_1RVZL2GbIrRCSjyebLzNEm7u',
    description: 'Die Einzellizenz für den KI-Kompetenznachweis nach EU AI Act der KI Navigatoren GmbH beinhaltet den Zugang zur Schulungsplattform, die Durchführung der Schulung sowie die Teilnahme am Abschlusstest samt Zertifikatserstellung.',
    mode: 'payment'
  }
} as const; */